import type { OrdersListParams, OrdersSummaryParams } from "./client";
import { useQuery } from "@tanstack/react-query";
import { ordersApi } from "./client";

export const ordersKeys = {
  list: (params: OrdersListParams) => ["orders", "list", params] as const,
  summary: (params: OrdersSummaryParams) =>
    ["orders", "summary", params] as const,
  detail: (id: string) => ["orders", "detail", id] as const,
};

export function useOrdersQuery(params: OrdersListParams = {}) {
  return useQuery({
    queryKey: ordersKeys.list(params),
    queryFn: () => ordersApi.list(params),
  });
}

export function useOrdersSummaryQuery(params: OrdersSummaryParams = {}) {
  return useQuery({
    queryKey: ordersKeys.summary(params),
    queryFn: () => ordersApi.summary(params),
  });
}

export function useOrderDetailQuery(id: string) {
  return useQuery({
    queryKey: ordersKeys.detail(id),
    queryFn: () => ordersApi.get(id),
    enabled: !!id,
  });
}
